import ReactDOM from 'react-dom';

const Portal = ({ children, domNode }) => ReactDOM.createPortal(children, domNode);

export default Portal;
